import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import NextBackground from '../../assets/abf/next.jpg'

const AppContainer = styled.div`
  background-color: #ffc706;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const AppContainerImage = styled.div`
  background-color: #ffc706;
  min-height: 100%;
  width: 100%;
  background-image: url(${NextBackground});
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15%;
`;

const PageNext: React.FC = () => {
  const navigate = useNavigate();
  return (
    <AppContainer>
      <AppContainerImage onClick={() => navigate('/register')}/>
    </AppContainer>
  );
};

export default PageNext;


